import React, { useContext } from 'react';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import { S as SimpleProduct } from '../../SimpleProduct-5QSyLGA2.js';
import { C as ConfigurableProduct } from '../../ConfigurableProduct-kQ650HKw.js';
import { a as ProductType } from '../../product-_pRduMz7.js';
import { CoreContext } from '../../context/index.js';
export { C as Counter } from '../../Counter-1FiHQxtY.js';
export { I as ItemCopy } from '../../ItemCopy-oXuu6VK5.js';
export { O as OptionsForm } from '../../OptionsForm-DEwtR6T4.js';
export { R as RelatedProducts } from '../../RelatedProducts-wOAHevPP.js';
export { U as UpsellProducts } from '../../UpsellProducts-Wc3lCklO.js';
export { P as Prices } from '../../Prices-J1SqTpik.js';
import 'react-i18next';
import 'notistack';
import 'next/router';
import 'next-i18next';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../index-dEXHnASi.js';
import 'i18next';
import '../../index-itNs9E93.js';
import '../../hooks/useShowError.js';
import '../../utils/error.js';
import '../../serverErrors-O6unZmFR.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../hooks/useShowNotify.js';
import '../../hooks/useWindowSize.js';
import '../../utils/product.js';
import 'lodash/get';
import '../../paths-ZKN3m62_.js';
import '../../helpers-WYINLSKJ.js';
import '../../cookies-VX_DpI1q.js';
import 'lodash';
import '../../hooks/useItemListName.js';
import '../../utils/dataRouteFormat.js';
import '../../utils/cart.js';
import '../../MergeCarts-sPldCtIn.js';
import '../../ProcessReactivateCart-uQs33rRl.js';
import '../../requestsCollection-A0HzS4ai.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../utils/isBot.js';
import '../../utils/currency.js';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-AU0vdOfm.js';
import '../../utils/saleFlag.js';
import '../../helper-qZTqmbEO.js';
import '../../utils/category.js';
import '../../GetCategoryBanner-HmQDOvcO.js';
import '../../GetCategoryYmals--jYLM2RK.js';
import '../../UrlResolver-OFrekbEP.js';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../modal-6vnX5SO3.js';
import '../Button/index.js';
import '../../index-2586sEvh.js';
import '../CircularProgress/index.js';
import '../Link/index.js';
import 'next/link';
import '../Breadcrumbs/index.js';
import '../WishlistButton/index.js';
import '../../storeSelectors/user.js';
import '../../storeSelectors/wishlist.js';
import '../../localStorage-h6SlcHvK.js';
import '../Loader/index.js';
import '../Modal/index.js';
import '../OnlyUIRender/index.js';
import '../Modal/ModalContent/index.js';
import 'react-dom';
import '../../hooks/useAutoFocus.js';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import '../Modal/ModalHeader/index.js';
import '../JustAddedProducts/index.js';
import '../ButtonGroup/index.js';
import '../../store/modal/index.js';
import '@reduxjs/toolkit';
import '../../store/modal/initialState.js';
import '../ImagesCarousel/index.js';
import '../../Carousel-sE6CEZCp.js';
import '../../a11y-f6LwtRzd.js';
import '../../breakpoints-X1SKRYyW.js';
import '../../Lightbox--QyVxi3g.js';
import '../../ImagesCarouselVertical-bJyvVPoG.js';
import '../../SaleFlag-uqbhEU3Y.js';
import '../../EcoFee-Ep6rIIu6.js';
import '../../storeSelectors/currencies.js';
import '../../AlmaBanner-qWjGjPhU.js';
import '../../ItemTabs-PRQx9xWO.js';
import '../../ItemsAccordion-dx5biVar.js';
import '../../ScrollToPlugin-k_fMCFg8.js';
import 'react-hook-form';
import '@hookform/resolvers/yup';
import 'lodash/pickBy';
import 'lodash/set';
import 'lodash/find';
import 'lodash/mergeWith';
import 'lodash/isEqual';
import '../../index-IjeQJOMv.js';
import 'yup';
import '../../validation-g1IuPS7K.js';
import '../InfoVariantModal/index.js';
import '../../Table-LdWI5rGH.js';
import '../../Gallery-lGbUPTvY.js';
import '../../SizeChart-PqebL4MS.js';
import '../../ColorField-KnBSINlL.js';
import '../../Colors-dSUpB4SX.js';
import '../../RadioGroup-ZDexyLRv.js';
import '../../RadioButton-iQCBhrqj.js';
import '../../SizeField-JNtoYwfb.js';
import '../../Sizes-tn0Bbk4S.js';
import '../../Select-LSn3KQwG.js';

const Product = ({ product, wishlistButton = true, outsideHeading = false, extraContent, accordionExtraContent, }) => {
    const { data: { siteConfig: { account: { accountGlobalEnable = false } = {} }, }, } = useContext(CoreContext);
    return (React.createElement(React.Fragment, null,
        product.type_id === ProductType.Simple && (React.createElement(SimpleProduct, { product: product, wishlistButton: wishlistButton && accountGlobalEnable, outsideHeading: outsideHeading, extraContent: extraContent, accordionExtraContent: accordionExtraContent })),
        product.type_id === ProductType.Configurable && (React.createElement(ConfigurableProduct, { product: product, wishlistButton: wishlistButton && accountGlobalEnable, outsideHeading: outsideHeading, extraContent: extraContent, accordionExtraContent: accordionExtraContent }))));
};
var Product$1 = withProviders(Product, { translation: true, snackbar: true });

export { SimpleProduct, Product$1 as default };
//# sourceMappingURL=index.js.map
